import React from "react";
import { Div, Row, Col, Image, Text } from "atomize";
import { OrderButton, PreviousButton, NextButton } from "../atoms/buttons";
import eBike1 from "../../assets/images/eBike1.png";
import ebike2 from "../../assets/images/ebike2.png";
import ebike3 from "../../assets/images/ebike3.png";

const EbikeCard = () => {
  return (
    <Div m={{ b: "2rem" }}>
      <Row m={{ t: "5rem", b: "2rem" }}>
        <Col size={{ xs: 12, md: 4 }}>
          <Div bg="#FFFFFF" shadow="4" p="1rem" rounded="20px" m="0.5rem">
            <h3>Universal eBike Kit</h3>
            <Div d="flex" justify="center">
              <Image src={eBike1} alt="ebike" w="300" h="200px" />
            </Div>
            <hr />
            <Div d="flex" justify="space-between" align="center">
              <Div>
                <Text textWeight="300">Price</Text>
                <Text TextSize="display1" textWeight="800">
                  $750
                </Text>
              </Div>
              <OrderButton />
            </Div>
          </Div>
        </Col>
        <Col size={{ xs: 12, md: 4 }}>
          <Div bg="#FFFFFF" shadow="4" p="1rem" rounded="20px" m="0.5rem">
            <h3>Brampoton eBike Kit</h3>
            <Div d="flex" justify="center">
              <Image src={ebike2} alt="ebike" w="300" h="200px" />
            </Div>
            <hr />
            <Div d="flex" justify="space-between" align="center">
              <Div>
                <Text textWeight="300">Price</Text>
                <Text TextSize="display1" textWeight="800">
                  $750
                </Text>
              </Div>
              <OrderButton />
            </Div>
          </Div>
        </Col>
        <Col size={{ xs: 12, md: 4 }} style={{ opacity: "0.5" }}>
          <Div bg="#FFFFFF" shadow="4" p="1rem" rounded="20px" m="0.5rem">
            <h3>Aditional eBike Kit</h3>
            <Div d="flex" justify="center">
              <Image src={ebike3} alt="ebike" w="300" h="200px" />
            </Div>
            <hr />
            <Div d="flex" justify="space-between" align="center">
              <Div>
                <Text textWeight="300">Price</Text>
                <Text TextSize="display1" textWeight="800">
                  $750
                </Text>
              </Div>
              <OrderButton />
            </Div>
          </Div>
        </Col>
      </Row>
      <Div d="flex" justify={{ xs: "center", md: "flex-end" }}>
        <PreviousButton />
        <NextButton />
      </Div>
    </Div>
  );
};

export default EbikeCard;
